import { useTranslation } from 'react-i18next';

import { useAppSelector } from 'redux/hooks';

import { Sticker } from 'components/Sticker';
import { StickerSize } from 'components/Sticker/Sticker.styles';

import * as S from './SoldSticker.styles';

interface Props {
  soldQty: number;
  isRemoved?: boolean;
  style?: React.CSSProperties;
  size?: StickerSize;
}

export const SoldSticker: React.FC<Props> = ({ soldQty, isRemoved = false, style, size }) => {
  const showSold = useAppSelector((state) => state.settings.showSold);
  const { t } = useTranslation();

  return (
    <S.SoldWrapper style={style}>
      {soldQty >= 0 && showSold && !isRemoved ? (
        <Sticker color="greenSecondary" size={size}>
          {`${t('product.sold')} ${soldQty.toString()}`}
        </Sticker>
      ) : undefined}
    </S.SoldWrapper>
  );
};
